import Head from 'next/head'
import { useRouter } from 'next/router'
import React, { useEffect, useState } from 'react'

import {
  HeaderBar,
  HeaderBarLeftAction,
  HeaderBarTitle,
} from '@wartek-id/header-bar'
import { Icon } from '@wartek-id/icon'

import { useGetPlaylistById } from 'api/video-repository/useAPIPlaylists'
import { VideoShimmer } from 'app/VideoRepository/components/Preloader'
import Video from 'app/VideoRepository/Video'
import { EmptyState, EmptyStateAction } from 'components/EmptyState'
import { SocialShareDrawer } from 'components/SocialShareDrawer'
import AndroidHandler from 'utils/androidHandler'

import type { PlaylistVideo } from 'types/video-inspirasi'

const VideoPage = () => {
  const { query } = useRouter()
  const { data, isSuccess, isError, isLoading } = useGetPlaylistById(
    query.id as string
  )
  const [currentVideo, setCurrentVideo] = useState<PlaylistVideo | null>(null)
  const [showShareDialog, setShowShareDialog] = useState(false)
  const androidHandler = AndroidHandler()
  const shareUrl = `${
    typeof window !== 'undefined'
      ? window.location.origin
      : process.env.NEXT_PUBLIC_BASE_URL
  }/video-inspirasi/playlists/video?id=${query.id}&video=${query.video}`
  const router = useRouter()

  useEffect(() => {
    if (isSuccess) {
      const video = data.data?.videos.find((v) => {
        return v.videoId === query.video
      })
      if (!!video) {
        setCurrentVideo(() => video)
      }
    }
  }, [data?.data?.videos, isSuccess, query?.video])

  const triggerShareDialog = () => {
    if (androidHandler.enabled) {
      androidHandler.shareToolkitUrl(
        `Lihat video: ${currentVideo.title} di ${shareUrl}`
      )
    } else {
      setShowShareDialog(true)
    }
  }

  return (
    <>
      <Head>
        <title>Video Inspirasi | Video {currentVideo?.title ?? ''} </title>
      </Head>

      <HeaderBar fixed className="z-10">
        <HeaderBarLeftAction
          icon={<Icon as="i">arrow_back</Icon>}
          onClick={() => {
            const isNewActivity = window.history.length <= 2
            if (isNewActivity) {
              if (androidHandler.enabled) {
                androidHandler.backToApp()
              } else {
                router.replace(`/playlists?id=${router.query.id}`)
              }
            } else {
              router.back()
            }
          }}
        />
        <HeaderBarTitle>Video Inspirasi</HeaderBarTitle>
      </HeaderBar>
      <div className="mt-14 pb-16">
        {isLoading && <VideoShimmer />}
        {isSuccess && !!currentVideo && (
          <>
            <Video
              playlistId={(query.id as string) ?? ''}
              title={currentVideo.title}
              videoId={currentVideo.videoId}
              description={currentVideo.description}
              duration={currentVideo.duration}
              publisherName={currentVideo.publisherName}
              publishedAt={currentVideo.publishedAt}
              onShareClick={triggerShareDialog}
            />
            <SocialShareDrawer
              isOpen={showShareDialog}
              title="Bagikan Video"
              onClose={() => {
                setShowShareDialog(false)
              }}
              shareText={`Lihat video: ${currentVideo.title} `}
              shareUrl={shareUrl}
            />
          </>
        )}
        {isError && (
          <EmptyState
            title={'Gagal mengambil data'}
            description={'Data Repository tidak dapat diakses'}
          >
            <EmptyStateAction onClick={() => window.location.reload()}>
              Muat Ulang
            </EmptyStateAction>
          </EmptyState>
        )}
      </div>
    </>
  )
}

export default VideoPage
